import script from "./CartPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartPayment.vue?vue&type=script&setup=true&lang=ts"

import "./CartPayment.vue?vue&type=style&index=0&id=3e5c943b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e5c943b"]])

export default __exports__